export const SchoolStatusType = [
  Object.freeze({
    id: "true",
    name: "SchoolSelected",
  }),
  Object.freeze({
    id: "false",
    name: "SchoolNotSelected",
  })
];

export const SchoolStatusTypeFilters = [
  Object.freeze({
    id: "",
    name: "All",
  }),
  ...SchoolStatusType,
];

export const getSchoolStatusTypeIdByName = (SchoolStatusTypeName) => {
  return (
    SchoolStatusType.find((SchoolStatusType) => SchoolStatusType.name === SchoolStatusTypeName)?.id ||
    ""
  );
};

export const getSchoolStatusTypeById = (id) => {
  return SchoolStatusType.find((SchoolStatusType) => SchoolStatusType.id === id) || "";
};

export const SchoolRequestType = [
  Object.freeze({
    id: "true",
    name: "SchoolRequested",
  }),
  Object.freeze({
    id: "false",
    name: "SchoolNotRequested",
  })
];

export const SchoolRequestTypeFilters = [
  Object.freeze({
    id: "",
    name: "All",
  }),
  ...SchoolRequestType,
];

export const getSchoolRequestTypeIdByName = (SchoolRequestTypeName) => {
  return (
    SchoolRequestType.find((SchoolRequestType) => SchoolRequestType.name === SchoolRequestTypeName)?.id ||
    ""
  );
};

export const getSchoolRequestTypeById = (id) => {
  return SchoolRequestType.find((SchoolRequestType) => SchoolRequestType.id === id) || "";
};